import { useCallback, useState } from 'react';
import { useNotify, useTranslate } from 'react-admin';

import { getErrorMessage } from '@sh4res/bo-common/utils';
import { translateBackendError } from '@sh4res/bo-common/utils/translate_error';

export function useBulkCreateErrorHandler() {
  const notify = useNotify();
  const translate = useTranslate();
  const [error, setError] = useState<string | null>(null);

  const onError = useCallback(
    (error: unknown) => {
      const message = getErrorMessage(error);
      const translatedBackendError = translateBackendError(
        {
          resource: 'resources.bo_common.b2b.employees.actions.bulk_create.errors',
          error: message,
        },
        (translation) => translate(translation),
      );
      setError(translatedBackendError);
      notify('resources.bo_common.b2b.employees.actions.bulk_create.failure', {
        type: 'warning',
        messageArgs: { error: translatedBackendError },
        multiLine: true,
      });
    },
    [notify, translate],
  );

  return { error, setError, onError };
}
